var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.nodeLevel === 9)?_c('dish-ranking-center'):_c('dish-ranking-global')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }